import {LEGACY_TO_NEW_ROUTE_MAP} from './legacy-to-new-route-map'

const MODULE_LABELS = {
  '/events': 'Eventos',
  '/license-plate': 'LPR',
  '/camera-mosaic': 'Mosaico de C�meras',
  '/facial-recognition': 'Reconhecimento Facial',
  '/registers/devices': 'Dispositivos',
  '/registers/clients': 'Clientes',
  '/registers/lists': 'Listas',
  '/registers/edge-servers': 'Servidores de Borda',
  '/administrative/companies': 'Empresas',
  '/administrative/quotas': 'Cotas',
  '/registers/users': 'Usu�rios',
  '/registers/alarm-centers': 'Central de Alarme',
  '/settings/inputs': 'Integra��es de Entrada',
  '/settings/outputs': 'Integra��es de Sa�da',
} as const

export type MigratedPortalModule = {
  id: string
  label: string | undefined
  legacyPath: string
  newPath: string
}

export const MIGRATED_PORTAL_MODULES: MigratedPortalModule[] = Object.entries(LEGACY_TO_NEW_ROUTE_MAP).map(([legacyPath, newPath]) => ({
  id: legacyPath.slice(1).replace(/-/g, '_'),
  label: MODULE_LABELS[legacyPath as keyof typeof MODULE_LABELS],
  legacyPath,
  newPath,
}))
